// extracted by mini-css-extract-plugin
module.exports = {"snsIcons":"Footer_snsIcons__7i1sO","footer":"Footer_footer__1G6Wy"};